import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetPresignedDocumentUploadURLForRespondentsRPC } from "./getPresignedDocumentUploadUrlForRespondentsRPC";

export class GetPresignedDocumentUploadURLForRespondentsRPCClientImpl extends GetPresignedDocumentUploadURLForRespondentsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetPresignedDocumentUploadURLForRespondentsRPC.Request): Promise<LeoRPCResult<GetPresignedDocumentUploadURLForRespondentsRPC.Response, GetPresignedDocumentUploadURLForRespondentsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "respondent/GetPresignedDocumentUploadURLForRespondents",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetPresignedDocumentUploadURLForRespondentsRPC.ResponseDTO,
      GetPresignedDocumentUploadURLForRespondentsRPC.Errors.ErrorsDTO,
      GetPresignedDocumentUploadURLForRespondentsRPC.Response,
      GetPresignedDocumentUploadURLForRespondentsRPC.Errors.Errors
    >(
      response,
      "respondent/GetPresignedDocumentUploadURLForRespondents",
      GetPresignedDocumentUploadURLForRespondentsRPC.Response.fromDTO,
      GetPresignedDocumentUploadURLForRespondentsRPC.Errors.fromDTO
    );
  }
}
